<template>
    <v-navigation-drawer
    class="navigation-drawer"
    :model-value="isVisible"
    @update:model-value="$emit('update:isVisible', $event)"
    location="end"
    :temporary="true"
  >
    <v-list density="compact" nav>
      <v-list-group
        v-for="menuGroup in menuGroups"
        :key="menuGroup.title"
        :value="menuGroup.title"
      >
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" :title="t(menuGroup.title)"></v-list-item>
        </template>
        <v-list-item
          v-for="(item, i) in menuGroup.items"
          :key="i"
          :title="t(item.text)"
          :to="item.path"
        ></v-list-item>
      </v-list-group>
    </v-list>

    <v-divider/>

    <v-list density="compact" nav>
      <v-list-item
        :title="t('contact')"
        class="text-center"
        variant="outlined"
        @click="$router.push({ name: 'Support' })"
      ></v-list-item>
    </v-list>

    <v-list-subheader class="ml-4" color="#5C9ED6">{{t('profile')}}</v-list-subheader>

        <v-list-item class="text-body-2">
      <template v-slot:prepend>
        <v-avatar color="primary" @click="$emit('profile-edit')">
          <span class="avatarIconText">{{ userInitials }}</span>
        </v-avatar>
      </template>
      {{ fullName }}
    </v-list-item>

    <v-divider/>

    <v-list v-if="translationDevelopment" density="compact" nav>
      <v-select
        v-model="locale"
        :items="locales"
        item-title="text"
        item-value="value"
        variant="underlined"
        dense
      ></v-select>
    </v-list>

    <v-list density="compact" nav>
      <v-list-item
        title="Logout"
        append-icon="mdi-logout"
        @click="$emit('logout')"
      ></v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();

defineProps({
  isVisible: {
    type: Boolean,
    required: true
  },
  menuGroups: {
    type: Array,
    required: true
  },
  userInitials: {
    type: String,
    required: true
  },
  fullName: {
    type: String,
    required: true
  },
  translationDevelopment: {
    type: Boolean,
    default: false
  },
  locales: {
    type: Array,
    default: () => [
      {text: 'Deutsch', value: 'de'},
      {text: 'English', value: 'en'},
      {text: 'Italiano', value: 'it'}
    ]
  }
});

defineEmits(['profile-edit', 'logout', 'update:isVisible']);
</script>

<script>
export default {
  name: 'MobileMenu'
}
</script>

<style scoped>
.avatarIconText {
  color: white;
}
</style>
